function DeliveryOrder(obj) {
  if (typeof obj !== "object") return {}

  // this.id = obj.id;
  this.shipping_method = obj.shipping_method || ""
  this.brand_code = obj.brand_code || ""
  this.carrier = obj.carrier || ""
  this.carrier_service = obj.carrier_service || ""
  //this.consolidation_allowed = obj.consolidated || ""
  this.customer_address1 = obj.customer_address1 || ""
  this.customer_address2 = obj.customer_address2 || ""
  this.customer_code = obj.customer_code || ""
  // this.reserved_6 = "";
  this.customer_city = obj.customer_city || ""
  this.customer_country = obj.customer_country || ""
  this.customer_email_address = obj.customer_email_address || ""
  // this.reserved_7 = "";
  this.customer_name = obj.customer_name || ""
  //this.customer_phone_num = obj.customer_phone_num;
  this.customer_postal_code = obj.customer_postal_code || ""
  this.customer_state = obj.customer_state || ""
  this.customer_code = obj.customer_code || ""
  this.customer = obj.customer || ""

  this.delivery_code = obj.delivery_code || ""
  this.sales_channel = obj.sales_channel || ""
  this.incoterm = (obj.ship_to_country == "AU" ? "" : obj.incoterm) || ""
  this.ship_to = obj.ship_to || ""
  this.ship_to_address1 = obj.ship_to_address1 || ""
  this.ship_to_address2 = obj.ship_to_address2 || ""
  this.ship_to_code = obj.ship_to_code || ""
  //this.ship_to_attention_to = obj.ship_to_attention_to || ""
  this.special_details_3 = obj.special_details_3 || ""
  this.ship_to_city = obj.ship_to_city || ""
  this.ship_to_country = obj.ship_to_country || ""
  this.ship_to_email_address = obj.ship_to_email_address || ""
  this.special_details_2 = obj.special_details_2 || ""
  this.ship_to_name = obj.ship_to_name || ""
  this.ship_to_phone_num = obj.ship_to_phone_num || ""
  this.ship_to_postal_code = obj.ship_to_postal_code || ""
  this.ship_to_state = obj.ship_to_state || ""
  this.erp_order = obj.erp_order || ""
  //this.scheduled_ship_date = obj.scheduled_ship_date || ""
  this.warehouse = obj.warehouse || ""
  this.delivery_instructions = obj.delivery_instructions || ""

  // Stray spaces (" Forestville") fail address validation. erp_order is left
  // as-is: it identifies the existing order on an update.
  Object.keys(this).forEach(key => {
    if (key !== "erp_order" && typeof this[key] === "string") this[key] = this[key].trim()
  })
}
export default DeliveryOrder
